/**
 * Block 1 · 1.3 · Eyebrow line primitive (Sebastian ruling 2026-09-09).
 *
 * A short uppercase line in letterspaced small caps, with a short
 * gold rule (56 px × 2 px, radius 999 px) beside it. Sits above the
 * main heading on every book screen. Text per screen ships in the
 * per-screen blocks (2 through 7); this file only owns the primitive.
 *
 * Spec constants (verbatim from Block 1):
 *   - Gold rule: 56 px wide, 2 px tall, radius 999 px (fully rounded)
 *   - Text: uppercase, letterspaced (tracking), small
 *
 * The rule sits BESIDE the text (left of it). Layout is flex-row
 * gapped; on very narrow phone widths the whole line stays on one
 * row — the text is short by design so wrap is unlikely, and any
 * wrap keeps the rule on the first line beside the first word.
 */

export interface EyebrowProps {
  /** The short uppercase text — authored per screen. */
  readonly text: string;
  /** Optional className passthrough for consumer-specific spacing. */
  readonly className?: string;
}

export function Eyebrow({ text, className }: EyebrowProps) {
  return (
    <div
      className={`flex items-center gap-3 text-xs font-medium tracking-[0.18em] text-book-text-secondary uppercase ${className ?? ''}`}
    >
      <span aria-hidden className="inline-block h-[2px] w-14 shrink-0 rounded-full bg-dream-gold" />
      <span>{text}</span>
    </div>
  );
}
